// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName

import { application } from "./application"

import TomSelectController from "./tom_select_controller"
application.register("tom-select", TomSelectController)

import FlatpickrController from "./flatpickr_controller"
application.register("flatpickr", FlatpickrController)

import ImaskController from "./imask_controller"
application.register("imask", ImaskController)

import PostcodePickerController from "./postcode_picker_controller"
application.register("postcode-picker", PostcodePickerController)

import OptionalFeesController from "./optional_fees_controller"
application.register("optional-fees", OptionalFeesController)

import CostTotalController from "./cost_total_controller"
application.register("cost-total", CostTotalController)

import RateCardController from "./rate_card_controller"
application.register("rate-card", RateCardController)
